import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { channelFetcher } from "../../api/requests";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useToaster } from "../../context/toaster";
import Container from "react-bootstrap/Container";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";

export default function CreateChannel() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();
  //  ------------------------------------------------------ Channel Data ---------------------------------------------
  const [channel, setChannel] = useState({
    avatar: "",
    banner: "",
    owner: 0,
    description: "",
    name: "",
    socials_address: [],
    confirm_to_channel: true,
    activation: true,
    published_date: new DateObject({
      calendar: persian,
      locale: persian_fa,
    }).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  });
  const [date, setDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa })
  );
  const user = Cookies.get("vaghfnamaUser");
  const parsedUser = JSON.parse(user ? user : "{}");
  const history = useHistory();
  const { addMessage } = useToaster();

  const handleChange = (name, value) => {
    setChannel({ ...channel, [name]: value });
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleUpload = async () => {
    // if (!video.video || !video.cover || !selectedTags.length || !video.channel) {
    //   console.error(
    //     "All fields including video, cover, tags, and channel are required."
    //   );
    //   return;
    // }

    const formData = new FormData();
    formData.append("avatar", channel.avatar);
    formData.append("banner", channel.banner);
    formData.append("name", channel.name);
    formData.append("owner", parsedUser.user_id);
    formData.append("description", channel.description);
    formData.append("confirm_to_channel", true);
    formData.append("activation", true);
    formData.append("published_date", channel.published_date);

    try {
      setLoading(true);
      const res = await channelFetcher.post(formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res) {
        setLoading(false);
        history.push("/account");
        showToast("success", "کانال با موفقیت ساخته شد.");
      }
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data);
      console.error("Upload error:", error.response?.data);
    }
  };

  const handleDateChange = (value) => {
    setDate(value.toString().replace(/\//g, "-"));
    setChannel({
      ...channel,
      published_date: value.toString().replace(/\//g, "-"),
    });
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          // maxWidth: "1500px",
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div>
          <Row
            style={{
              marginLeft: "0px",
              marginRight: "0px",
              padding: "15px",
            }}
          >
            <Col lg={12}>
              <div className="osahan-form">
                <Row>
                  <Col lg={12}>
                    <Form.Group controlId="video-title">
                      <Form.Label>نام کانال</Form.Label>
                      <Form.Control
                        onChange={(e) => handleChange("name", e.target.value)}
                        type="text"
                        placeholder="نام..."
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Group controlId="video-description">
                      <Form.Label>درباره</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="توضیحات..."
                        onChange={(e) =>
                          handleChange("description", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={3}>
                    <Form.Group controlId="video-upload">
                      <Form.Label>آواتار</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleChange("avatar", e.target.files[0])
                        }
                        className="form-control-file"
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={3}>
                    <Form.Group controlId="cover-upload">
                      <Form.Label>بنر</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleChange("banner", e.target.files[0])
                        }
                        className="form-control-file"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={4}>
                    <Form.Group controlId="video-casting">
                      <Form.Label
                        style={{ marginLeft: "10px", marginTop: "20px" }}
                      >
                        تاریخ انتشار
                      </Form.Label>
                      <DatePicker
                        // value={date}
                        onChange={handleDateChange}
                        format="YYYY/MM/DD HH:mm:ss"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <div className="osahan-area text-center mt-3">
                <Button
                  variant="outline-primary"
                  onClick={handleUpload}
                  style={{
                    cursor: loading ? "wait" : "pointer",
                  }}
                >
                  {loading ? "لطفا منتظر بمانید..." : "ارسال"}
                </Button>
                {errors &&
                  Object.keys(errors).map(
                    (field) =>
                      errors[field].length > 0 && (
                        <p className="text-danger mt-2" key={field}>{`${
                          field.charAt(0).toUpperCase() + field.slice(1)
                        } ${errors[field][0]}`}</p>
                      )
                  )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
}
